import { useState } from 'react';
import { Link } from 'react-router-dom';
import { Lock, X } from 'lucide-react';
import { useAuthStore } from '../../store/auth';

const DISMISS_KEY = 'lizrd.mfaNudgeDismissed';

/**
 * A calm, dismissible invitation to turn on MFA (Feature 25) — the gentle,
 * opt-in pattern. Shown only to real customers who haven't enrolled and haven't
 * dismissed it; never blocks anyone. Sandbox guests (passwordless) are exempt.
 */
export function MfaNudge() {
  const user = useAuthStore((s) => s.user);
  const [dismissed, setDismissed] = useState(() => {
    try {
      return localStorage.getItem(DISMISS_KEY) === '1';
    } catch {
      return false;
    }
  });

  if (!user || user.mfaEnabled || user.organizationKind === 'SANDBOX' || dismissed) {
    return null;
  }

  function dismiss() {
    try {
      localStorage.setItem(DISMISS_KEY, '1');
    } catch {
      // best-effort; hiding for the session is enough
    }
    setDismissed(true);
  }

  return (
    <div className="mb-6 flex flex-wrap items-center justify-between gap-3 rounded-md border border-hairline bg-surface-2 px-4 py-3">
      <div className="flex min-w-0 items-center gap-3">
        <Lock aria-hidden className="h-5 w-5 flex-none text-iris" />
        <p className="text-sm text-haze">
          <span className="font-medium text-bone">Add an extra layer of security.</span> Protect
          your account with two-factor authentication.
        </p>
      </div>
      <div className="flex flex-none items-center gap-2">
        <Link
          to="/profile"
          className="rounded-sm bg-iris px-3 py-1.5 text-xs font-semibold text-on-iris transition-colors hover:bg-iris-strong"
        >
          Set up
        </Link>
        <button
          type="button"
          onClick={dismiss}
          aria-label="Dismiss"
          className="grid h-6 w-6 place-items-center rounded-sm text-muted transition-colors hover:bg-surface hover:text-bone"
        >
          <X aria-hidden className="h-4 w-4" />
        </button>
      </div>
    </div>
  );
}
